module.exports = __webpack_public_path__ + "static/media/govenmentOrganization.84dc4d40.webp";